<div class="alert alert-info" role="alert">
    <i class="fas fa-exclamation"></i> No existe información a mostrar.
</div>